var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-page',{attrs:{"title-text":"处分信息管理","request":_vm.request,"column-list":_vm.columnList,"form-parms-add":_vm.formParmsAdd,"tableActions":_vm.tableActions,"table-size":"large","dealSearchParm":_vm.dealSearchParm,"dealFormData":_vm.dealFormData,"form-parms-update":_vm.formParmsUpdate,"tableActionsFixed":true,"need-data-file":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }